/* eslint-disable react/prop-types */
import { MenuItem, FormControl, Select, InputLabel } from '@material-ui/core'
import Dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import { isEmpty } from 'lodash'
import React from 'react'

import Loading from 'app/components/generic/Loading'

import * as Styles from './styles'

Dayjs.extend(isSameOrAfter)

const SchedulesDate = ({
  isCheckoutMode = false,
  batchId,
  value,
  handleOnChange,
  selectedBatchType,
  scheduleFunction,
  propertyChange,
  placeholder,
  disabled,
  batchInfo,
  dateFormat = 'ddd, D MMM YYYY'
}) => {
  const [scheduledEvents, setScheduledEvents] = React.useState({
    isLoaded: false,
    data: []
  })

  const handleScheduleData = async () => {
    setScheduledEvents((state) => ({ ...state, isLoaded: false }))
    try {
      const scheduleEvent = await scheduleFunction(
        selectedBatchType,
        batchId,
        handleOnChange,
        batchInfo?.discoveryEndDate,
        batchInfo?.resubscribeStartDate
      )
      setScheduledEvents((state) => ({
        ...state,
        data: scheduleEvent || []
      }))
    } catch (error) {
      console.log('error in handling scheduled events :- ', error)
    } finally {
      setScheduledEvents((state) => ({ ...state, isLoaded: true }))
    }
  }

  React.useEffect(() => {
    if (scheduleFunction) {
      handleScheduleData()
    }
  }, [scheduleFunction, batchId])

  const onChange = (e) => {
    const { name: batchId, value } = e.target
    const selectedItem = scheduledEvents.data.find(
      (item) => item.value === value
    )

    if (selectedItem) {
      handleOnChange(batchId, propertyChange, {
        label: selectedItem.label,
        value
      })
    }
  }

  const labelId = `${placeholder.split(' ').join('-')}-label`

  if (!scheduledEvents.isLoaded) {
    return <Loading />
  }

  return (
    <>
      <Styles.FormControl variant="outlined" disabled={disabled} size="small">
        <InputLabel id={labelId}>{placeholder}</InputLabel>
        <Select
          labelId={labelId}
          name={batchId}
          value={value?.value || ''}
          disabled={disabled}
          onChange={onChange}
          label={placeholder}>
          {scheduledEvents?.data?.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {Dayjs(item.label).format(dateFormat)}
            </MenuItem>
          ))}
        </Select>
      </Styles.FormControl>
    </>
  )
}

export { SchedulesDate }
